import { render, staticRenderFns } from "./contentList_mobile.vue?vue&type=template&id=f95d0942&scoped=true&"
import script from "./contentList_mobile.vue?vue&type=script&lang=js&"
export * from "./contentList_mobile.vue?vue&type=script&lang=js&"
import style0 from "./contentList_mobile.vue?vue&type=style&index=0&id=f95d0942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95d0942",
  null
  
)

export default component.exports